(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
      this.setupDeferredLogo();
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
      this.logoObserver?.disconnect();
      this.logoMedia?.removeEventListener('change', this.onLogoStateChange);
      this.normalLogoImage?.removeEventListener('load', this.onNormalLogoLoad);
    }

    // InsCoder 2026-09-03: follow the existing transparent-header CSS states.
    setupDeferredLogo() {
      this.normalLogoPicture = this.querySelector('picture[data-deferred-logo]');
      if (!this.normalLogoPicture || !this.header) return;
      this.normalLogoImage = this.normalLogoPicture.querySelector('img');
      if (!this.normalLogoImage) return;

      this.setAttribute('data-normal-logo-pending', '');
      this.onNormalLogoLoad = () => {
        if (!this.normalLogoImage.naturalWidth) return;
        this.removeAttribute('data-normal-logo-pending');
        this.normalLogoPicture.removeAttribute('data-deferred-logo');
        this.logoObserver?.disconnect();
        this.logoMedia?.removeEventListener('change', this.onLogoStateChange);
      };
      this.normalLogoImage.addEventListener('load', this.onNormalLogoLoad);
      if (this.normalLogoImage.complete && this.normalLogoImage.naturalWidth) {
        this.onNormalLogoLoad();
        return;
      }

      this.logoMedia = window.matchMedia('(min-width: 750px)');
      this.onLogoStateChange = this.hydrateNormalLogoIfNeeded.bind(this);
      this.logoObserver = new MutationObserver(this.onLogoStateChange);
      this.logoObserver.observe(this.header, { attributes: true, attributeFilter: ['class'] });
      this.logoObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
      this.logoMedia.addEventListener('change', this.onLogoStateChange);
      this.hydrateNormalLogoIfNeeded();
    }

    hydrateNormalLogoIfNeeded() {
      if (!this.normalLogoPicture || !this.normalLogoImage?.dataset.src) return;

      const bodyClasses = document.body.classList;
      const drawerOpen = ['menu-drawer--open', 'menu-drawer--opening', 'menu-drawer--closing']
        .some((name) => bodyClasses.contains(name));
      const desktopActive = this.logoMedia.matches && (
        this.header.classList.contains('is-hover') || this.header.classList.contains('is-active') ||
        ['mini-cart--open', 'mini-cart--opening', 'menu-mobile--open', 'menu-mobile--opening', 'localization--open']
          .some((name) => bodyClasses.contains(name))
      );
      if (!drawerOpen && !desktopActive && !this.header.classList.contains('shopify-section-header-sticky')) return;

      this.normalLogoImage.loading = 'eager';
      // Set picture sources before the fallback image to avoid desktop downloads on mobile.
      this.normalLogoPicture.querySelectorAll('[data-srcset]').forEach((node) => {
        node.setAttribute('srcset', node.dataset.srcset);
        node.removeAttribute('data-srcset');
      });
      this.normalLogoImage.src = this.normalLogoImage.dataset.src;
      this.normalLogoImage.removeAttribute('data-src');
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
